import { FC, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import useAppModal from 'hooks/useAppModal';
import useAppSelector from 'hooks/useAppSelector';
import { MESSAGE_LOG_VIEW_MODAL_ID } from './modal/view/MessageLogViewModal.constants';
import useMessageLogViewModal from './modal/view/useMessageLogViewModal';

const MessageLogModal: FC = () => {
  const { key } = useParams();
  const hasInit = useRef(false);
  const activeModals = useAppSelector((state) => state.modal.activeModals);
  const { closeModal } = useAppModal();
  const { openViewMessageLogModal } = useMessageLogViewModal();

  useEffect(() => {
    if (key && !activeModals[MESSAGE_LOG_VIEW_MODAL_ID] && !hasInit.current) {
      openViewMessageLogModal({ messageLogUid: key });
      hasInit.current = true;
    }
  }, [key, activeModals, openViewMessageLogModal]);

  useEffect(() => {
    return () => {
      if (hasInit.current) {
        closeModal(MESSAGE_LOG_VIEW_MODAL_ID);
        hasInit.current = false;
      }
    };
  }, [closeModal]);

  return null;
};

export default MessageLogModal;
